module.exports = __webpack_public_path__ + "img/glider_black.039a7724.png";